'use client'

import { useLessonViewModel } from '@entities/lesson'
import { useTranslation } from '@shared/config/i18n'

import { BadgeV1, HStack, Typography } from '@podo-app/design-system-temp'

type Props = {
  badgeVisible?: boolean
}

export const LessonCardHeader = ({ badgeVisible = false }: Props) => {
  const { viewModel } = useLessonViewModel()
  const t = useTranslation()
  return (
    <HStack className="gap-2">
      <Typography size="h2" className="line-clamp-2 flex-1 break-keep" asChild={false}>
        {viewModel.entity.bookName}
      </Typography>
      {badgeVisible && <BadgeV1 variant={viewModel.statusColor}>{t(`lesson.status.${viewModel.status}`)}</BadgeV1>}
    </HStack>
  )
}
